// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"BreadcrumbsItem_breadcrumb__8zZOr","breadcrumbInactive":"BreadcrumbsItem_breadcrumbInactive__1SBOc","breadcrumbActive":"BreadcrumbsItem_breadcrumbActive__2zqF3"};